// eslint-disable-next-line
import { BlankLayout } from '@/layouts'

export const asyncRouterMap = []

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [

  // 注册页面
  {
    path: '/',
    name: 'index',
    component: BlankLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        meta: { title: '实时监测', keepAlive: false },
        component: () => import('@/views/home')
      },
      {
        path: 'analysis',
        name: 'analysis',
        meta: { title: '数据分析', keepAlive: false },
        redirect: 'day',
        component: () => import('@/views/analysis'),
        children:[
          {
            path: '/day',
            name: 'day',
            meta: { title: '数据分析', keepAlive: true },
            component: () => import('@/views/day'),
          },
          {
            path: '/week',
            name: 'week',
            meta: { title: '数据分析', keepAlive: true },
            component: () => import('@/views/week'),
          },
          {
            path: '/month',
            name: 'month',
            meta: { title: '数据分析', keepAlive: true },
            component: () => import('@/views/month'),
          },
          {
            path: '/custom',
            name: 'custom',
            meta: { title: '数据分析', keepAlive: true },
            component: () => import('@/views/custom'),
          }
        ]
      }
    ]
  }
]
